import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import classes from "./AppDownload.module.scss";
import LazyImage from "@Components/Image";
import CustomLink from "@Components/CustomLink";
import getImagePath from "@Utils/getImagePath";
import config from "config/index";
import {
  APP_DOWNLOAD_APP_STORE_LINK,
  APP_DOWNLOAD_PLAY_STORE_LINK,
  ICP_URL,
} from "constants/configConstants";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import useIsApp from "hooks/useIsApp";
import useCustomWindowOpen from "@Components/CustomWindowOpen";

const AppDownload = ({ isDesktop = false }) => {
  const { t } = useTranslationHook();
  const customWindowOpen = useCustomWindowOpen();
  const getAppText = t("home.footer.gettheapp");
  const paymentOptions = t("home.footer.paymentoptions");
  const isApp = useIsApp();

  if (isApp) return <></>;

  return (
    <>
      {!config.IS_CHINA_APP ? (
        <div className={formatClassNames(classes.outerContainer, isDesktop && classes.desktop)}>
          <div className={classes.container}>
            <div data-testid="footer-get-amber-app" className={classes.headerText}>
              {getAppText}
            </div>
            <div className={classes.imageWrapper}>
              {!config.IS_CHINA_APP ? (
                <CustomLink
                  href={APP_DOWNLOAD_PLAY_STORE_LINK}
                  target="_blank"
                  rel="noreferrer"
                  isExternal
                  dataTestId="footer-get-app-link-Playstore"
                >
                  <LazyImage
                    dataTestId="Play-store-Image"
                    src={getImagePath(`${config.IMAGE_STATIC_URL}/images/playstore-android.svg`)}
                    alt="play store"
                    className={classes.img}
                    height="20px"
                    width="20px"
                  />
                </CustomLink>
              ) : (
                <></>
              )}
              <CustomLink
                href={APP_DOWNLOAD_APP_STORE_LINK}
                target="_blank"
                rel="noreferrer"
                isExternal
                dataTestId="footer-get-app-link-Appstore"
              >
                <LazyImage
                  dataTestId="App-store-Image"
                  src={getImagePath(`${config.IMAGE_STATIC_URL}/images/app-store.svg`)}
                  alt="app store"
                  className={classes.img}
                  height="20px"
                  width="20px"
                />
              </CustomLink>
            </div>
          </div>

          <div className={classes.divider} />

          <div className={classes.container}>
            <div data-testid="footer-payment-options" className={classes.headerText}>
              {paymentOptions}
            </div>
            <div>
              <LazyImage
                dataTestId="footer-payment-options-image"
                src={getImagePath(`${config.IMAGE_STATIC_URL}/images/footer_payment_partners.svg`)}
                alt="payment-partners"
                className={classes.imgPartners}
                height="28px"
                width="158px"
              />
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className={classes.ChinaOuterContainer}>
            <div className={classes.container}>
              <div data-testid="footer-get-amber-app" className={classes.headerText}>
                {getAppText}
              </div>
              <div className={classes.imageWrapper}>
                {!config.IS_CHINA_APP ? (
                  <CustomLink
                    href={APP_DOWNLOAD_PLAY_STORE_LINK}
                    target="_blank"
                    rel="noreferrer"
                    isExternal
                    dataTestId="footer-get-app-link-Playstore"
                  >
                    <LazyImage
                      dataTestId="Play-store-Image"
                      src={getImagePath(`${config.IMAGE_STATIC_URL}/images/google_store_china.svg`)}
                      alt="play store"
                      className={classes.img}
                      height="20px"
                      width="35px"
                    />
                  </CustomLink>
                ) : (
                  <></>
                )}
                <CustomLink
                  href={APP_DOWNLOAD_APP_STORE_LINK}
                  target="_blank"
                  rel="noreferrer"
                  isExternal
                  dataTestId="footer-get-app-link-Appstore"
                >
                  <LazyImage
                    dataTestId="App-store-Image"
                    src={getImagePath(`${config.IMAGE_STATIC_URL}/images/app-store.svg`)}
                    alt="app store"
                    className={classes.img}
                    height="20px"
                    width="20px"
                  />
                </CustomLink>
              </div>
            </div>

            <div className={classes.divider} />

            <div className={classes.container}>
              <div className={classes.headerText}>{paymentOptions}</div>
              <div>
                <LazyImage
                  src={getImagePath(
                    `${config.IMAGE_STATIC_URL}/images/footer_payment_partners.svg`,
                  )}
                  alt="payment-partners"
                  className={classes.imgPartners}
                  height="28px"
                  width="158px"
                />
              </div>
            </div>
          </div>

          <div className={classes.ICPContainer}>
            <div className={classes.outerChinaContainer}>
              <div className={classes.chinaContainer}>
                {/* <div className={classes.headerdiv}>{t("Chat on WeChat")}</div> */}
                {/* <LazyImage src={WECHAT_QR_URL} alt="qr-1" height="80px" width="80px" /> */}
              </div>
              <div className={classes.chinaContainer}>
                {/* <div className={classes.headerdiv}>小红书</div> */}
                {/* <LazyImage src={XHR_QR_URL} alt="qr-2" height="80px" width="80px" /> */}
              </div>
            </div>
            <div className={classes.ICPLabel}>沪ICP备2025113550号-1</div>
            <div
              className={classes.ICPUrl}
              role="link"
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  customWindowOpen({ url: ICP_URL, target: "_blank", isExternal: true });
                }
              }}
              onClick={() => customWindowOpen({ url: ICP_URL, target: "_blank", isExternal: true })}
            >
              {ICP_URL}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default wrapperHOC(AppDownload, {
  componentName: "AppDownload-FooterV2-Global",
  showForChina: true,
});
